import { render, staticRenderFns } from "./DictionaryDataView.vue?vue&type=template&id=0c752084&scoped=true"
import script from "./DictionaryDataView.vue?vue&type=script&lang=js"
export * from "./DictionaryDataView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c752084",
  null
  
)

export default component.exports